<template>
  <div v-if="visible" class="full-screen-dialog-overlay">
    <div class="full-screen-dialog-content">
      <!-- 弹框头部 -->
      <div class="flow_dialog-header">
        <div class="close-btn" @click="closeDialog">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="flow_dialog-title">核心业务场景操作流程</div>
      <!-- 标签栏 -->
      <div class="tabs">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="flow_tab"
          :class="{ 'active-tab': currentTab === index }"
          @click="currentTab = index"
        >
          {{ tab }}
        </div>
      </div>
      <!-- 内容区域，这里简单模拟，可根据实际需求替换 -->
      <div class="dialog-body" v-show="currentTab === 0 || currentTab === 3">
        <div v-show="currentTab === index" v-for="(item, index) in tabsContent" class="tab_content-item" :key="item.title + index">
          <div class="tab_content-item-title">{{ item.title }}</div>
          <div class="tab_content-item-content">{{ item.content }}</div>
          <div class="tab_content-item-apps">
            <div class="tab_content-item-app" v-for="(val, ind) in item.apps" :key="val.name + ind" @click="clickApp(val)">
              <div class="item-app-title">{{ val.name }}</div>
              <img :src="val.icon" alt="" width="60px" height="60px"/>
              <div class="tab_content-item-app-description">{{ val.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-body" v-show="currentTab === 1">
        <div class="ability_container">
          <div class="ability_item" v-for="(item, index) in tabsContent[1].apps" :key="item.title + index">
            <div class="ability_item-title">{{ item.title }}</div>
            <div class="ability_item-content">
              <div class="ability_item-content-item" v-for="(val, ind) in item.appItems" :key="val.id + ind" @click="clickApp(val)">
                <div class="ability_item-content-title">{{ val.name }}</div>
                <img class="ability_item-content-img" :src="val.icon" alt="">
                <div class="ability_item-content-desc">{{ val.description }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 40px;" class="tab_content-item-content">{{ tabsContent[1].content }}</div>
      </div>
      <div class="dialog-body" v-show="currentTab === 2">
        <div class="tab_content-item" >
          <div class="tab_content-item-title" style="margin-top: 40px;">{{ tabsContent[2].title }}</div>
          <div class="tab_content-item-content">{{ tabsContent[2].content }}</div>
          <div class="tab_content-item-apps" style="margin-top: 20px;">
            <img src="@/assets/imgs/data_core.png" alt="" width="150px" height="380px" style="margin-right: 12px; ">
            <div class="tab_content-item-first_app">
              <div class="first_app-item" v-for="(value, index) in tabsContent[2].firstApps" :key="value.id + index" @click="clickApp(value)">
                <div class="first_app-item-title">{{ value.name }}</div>
                <img class="first_app-item-img" :src="value.icon" alt="">
                <!-- <div class="first_app-item-desc">{{ value.description }}</div> -->
              </div>
              <div class="first_app-footer">
                ...
              </div>
            </div>
            <div class="tab_content-item-app" v-for="(val, ind) in tabsContent[2].apps" :key="val.name + ind" @click="clickApp(val)">
              <div class="item-app-title">{{ val.name }}</div>
              <img :src="val.icon" alt="" width="60px" height="60px"/>
              <div class="tab_content-item-app-description">{{ val.description }}</div>
            </div>
            <div class="tab_content-item-second_app">
              <div class="first_app-item" v-for="(value, index) in tabsContent[2].secondApps" :key="value.id + index" @click="clickApp(value)">
                <div class="first_app-item-title">{{ value.name }}</div>
                <img class="first_app-item-img" :src="value.icon" alt="">
              </div>
              <div class="first_app-footer">
                ...
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-body" v-show="currentTab === 5">
        <div class="tab_content-item">
          <div class="tab_content-item-title">{{ tabsContent[5].title }}</div>
          <div class="tab_content-item-content">{{ tabsContent[5].content }}</div>
          <div class="tab_content-item-apps" style="gap: 20px; margin-top: 70px;">
            <div class="tab_content-item-app-special" v-for="(val, ind) in tabsContent[5].apps" :key="val.name + ind" @click="windowOpen(val.url)">
              <img :src="val.img" alt="" width="100px" height="100px"/>
              <div class="item-app-title-special">{{ val.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-body" v-show="currentTab === 4">
        <div  class="tab_content-item" >
          <div class="tab_content-item-title">{{ tabsContent[4].title }}</div>
          <div class="tab_content-item-content">{{ tabsContent[4].content }}</div>
          <div class="tab_content-item-apps">
            <div class="tab_content-item-app special-app" v-for="(val, ind) in tabsContent[4].firstApps" :key="val.name + ind" @click="clickApp(val)">
              <div class="item-app-title">{{ val.name }}</div>
              <img :src="val.icon" alt="" width="60px" height="60px"/>
              <div class="tab_content-item-app-description">{{ val.description }}</div>
            </div>
            <div class="tab_content-item-app-second">
              <img class="zuoshang_img second_app-item-img" src="@/assets/imgs/youshang_img.png" alt="">
              <img class="zuoxia_img second_app-item-img"  src="@/assets/imgs/zuoshang_img.png" alt="">
              <img class="youshang_img second_app-item-img"  src="@/assets/imgs/youshang_img.png" alt="">
              <img class="youxia_img second_app-item-img"  src="@/assets/imgs/zuoshang_img.png" alt="">
              <div class="first_app-item-new"  v-for="(value, index) in tabsContent[4].secondApps" :key="value.id + index" @click="clickApp(value)">
                <div class="first_app-item-title-new">{{ value.name }}</div>
                <img class="first_app-item-img-new" :src="value.icon" alt="">
                <!-- <div class="first_app-item-desc">{{ value.description }}</div> -->
              </div>
              <div class="lcode_apps first_app-item-new">
                <div class="lcode_app">办公应用</div>
                <div class="lcode_app">组态应用</div>
                <div class="lcode_app">BI应用</div>
                <div class="lcode_app">...</div>
              </div>
            </div>
            <div class="tab_content-item-app" v-for="(val, ind) in tabsContent[4].thirdApps" :key="val.name + ind" @click="windowOpen(val.url)">
              <div class="item-app-title">{{ val.name }}</div>
              <img :src="val.icon" alt="" width="60px" height="60px"/>
              <div class="tab_content-item-app-description">{{ val.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import microApp from '@micro-zoe/micro-app'
import {
  getAppApplyUrl
} from '@/api/app.js'
export default {
  data() {
    return {
      visible: false,
      tabs: ['组装式集成', '能力共享', '数据贯通', '智能驱动', '应用开发生命全周期管理', '工业应用与行业适配'],
      tabsContent: [
        {
          title: '一体化、组装式',
          content: '以插拔的方式集成软件产品,支持按客户需求快速组装, 满足定制需求；用户使用习惯与体验高度一致',
          apps: [
            {
              'id': 1079871304447819776,
              'name': 'PBC管控',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/80a18482-1c2d-4714-ba7a-050d22dfcfca.png',
              'context': 'admin',
              'type': 'INNER_APP',
              'url': 'admin',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1079871304447819776&appName=PBC管控',
              'enterNeedFresh': 0,
              description: '配置集成应用'
            },
            {
              'id': 622076759805923328,
              'name': 'IAM',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/aa39eae8-3328-43c1-825e-75221afd1b2c.png',
              'context': 'eiam-mgt',
              'type': 'MICRO_APP',
              'url': 'https://sso.cosmoplat.com/eiam-mgt/#/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=622076759805923328&appName=IAM',
              'enterNeedFresh': 0,
              description: '管理用户、组织、应用单点、菜单、权限'
            },
            {
              'id': 1742723313642762496,
              'name': '工作台管理',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/3d8a39cc-4a0c-4337-a337-e875d9912665.png',
              'context': 'workbench',
              'type': 'MICRO_APP',
              'url': 'https://workplace-pre.hdt.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1742723313642762496&appName=工作台管理',
              'enterNeedFresh': 0,
              description: '上架卡片，配置工作台'
              // icon: '	http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/3d8a39cc-4a0c-4337-a337-e875d9912665.png'
            },
            {
              'id': 1943184586536259584,
              'name': '系统管理',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/10/0db35256-53e1-4a41-8cfc-ecbc6318a29a.png',
              'context': 'manager',
              'type': 'INNER_APP',
              'url': 'https://eiip.hdt.cosmoplat.com/',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '高度个性化配置'
              // icon: '	http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/3d8a39cc-4a0c-4337-a337-e875d9912665.png'
            }
          ]
        },
        {
          title: '能力共享',
          content: '资源统管、能力共享。减少重复建设、统一标准、提升质量及稳定性',
          apps: [
            {
              title: '数据中心资源共享',
              appItems: [
                {
                  name: '云管平台',
                  'id': 1926961560283123712,
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/07/1a3d2c57-6380-4c29-8720-28ba9ec458cc.png',
                  'context': 'ucloud',
                  'type': 'HREF',
                  'url': 'https://sso.cosmoplat.com/sign/authz/oauth/v20/authorize?client_id=1926961560283123712&redirect_uri=https://ucloud.s.cosmoplat.com/oauth/callback&response_type=code&state=ucloud.cn',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1926961560283123712&appName=优云云管',
                  'enterNeedFresh': 0,
                  description: '云服务器管理'
                },
                {
                  name: '多云管理',
                  'id': 1930236217849417728,
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/07/5f64fe8c-3074-4e6d-bb6e-981a2f14e6f2.png',
                  'context': 'ucmp',
                  'type': 'HREF',
                  'url': 'https://sso.cosmoplat.com/sign/authz/oauth/v20/authorize?client_id=1930236217849417728&redirect_uri=https://ucmp.s.cosmoplat.com&response_type=code&state=ucmp.cn',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1930236217849417728&appName=优云多云管理',
                  'enterNeedFresh': 0,
                  description: '设备连接'
                }
              ]
            },
            {
              title: '能力共享市场',
              appItems: [
                {
                  'id': 1916409953946570752,
                  'name': 'OpenAPI',
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/05/22/d800461a-ea07-4e93-9b76-15cf7d7867af.png',
                  'context': 'openapi',
                  'type': 'MICRO_APP',
                  'url': 'https://apiconsole.hdt.cosmoplat.com/',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1916409953946570752&appName=OpenAPI',
                  'enterNeedFresh': 1,
                  description: 'API创建、授权'
                },
                {
                  'id': 1914633893496098816,
                  'name': '能力市场',
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/05/22/e8977a17-1e12-4861-8e73-286f0f0ed10c.png',
                  'context': 'capacityWeb',
                  'type': 'MICRO_APP',
                  'url': 'https://api.y.cosmoplat.com',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1914633893496098816&appName=能力市场',
                  'enterNeedFresh': 0,
                  description: '能力'
                }
              ]
            },
            {
              title: '服务资源共享',
              appItems: [
                {
                  'id': 1077220875662524416,
                  'name': '容器云',
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/27/520e35a2-8ea8-46a5-9d09-c10b15524f06.png',
                  'context': 'cke',
                  'type': 'MICRO_APP',
                  'url': ' https://container.y.cosmoplat.com/',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1077220875662524416&appName=容器云',
                  'enterNeedFresh': 0,
                  description: '镜像管理、服务部署'
                },
                {
                  'id': 1084527494549209088,
                  'name': '微库',
                  'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/43943095-0f47-4330-aab7-4fb2f9004da1.png',
                  'context': 'mysql',
                  'type': 'MICRO_APP',
                  'url': 'https://mysql-private.hdt.cosmoplat.com/',
                  'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1084527494549209088&appName=微库',
                  'enterNeedFresh': 0,
                  description: '实例管理、SQL执行'
                }
              ]
            }
          ]
        },
        {
          title: '数据贯通',
          content: '打破数据孤岛，通过治理和分析将原始数据转化为业务价值，同时兼顾效率、成本与安全性',
          firstApps: [
            {
              'id': 1904089622397456384,
              'name': '物联IOT',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/8ae45db8-c595-4027-b34a-599144489c3e.png',
              'context': 'iot',
              'type': 'HREF',
              'url': 'https://cosmo-iot.hdt.cosmoplat.com/mom/oauthLogin?clientId=1904089622397456384',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1904089622397456384&appName=IOT物联',
              'enterNeedFresh': 0,
              description: '设备连接'
            },
            {
              'id': 1967770857807941632,
              'name': '园区管理',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/16/2dbaa2f5-b4a5-4fc6-addc-b126065c6294.png',
              'context': 'chem',
              'type': 'HREF',
              'url': 'https://chem.cosmoplat.com/workbench/index?XUserType=view',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '设备连接'
            },
            {
              'id': 1983801830173446144,
              'name': '智慧能源',
              'icon': 'https://oss.hdt.cosmoplat.com/portal-base/2025/10/30/6945ee11-ef03-40f7-9d40-d7976711a4c5.png',
              'context': 'ems',
              'type': 'HREF',
              'url': 'https://iems.cosmoplat.com/#/jumpSphereOs',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '设备连接'
            },
            {
              'id': 1970733878465400832,
              'name': '大模型',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/24/6618fa9a-c849-4091-b896-d3747a5d1c30.png',
              'context': 'tzModel',
              'type': 'MICRO_APP',
              'url': 'https://devagent.hdt.cosmoplat.com/developAgent/',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '设备连接'
            }
          ],
          apps: [
            {
              'id': 1897194195379163136,
              'name': '天数大数据',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/5e15cc1c-f1f0-45d4-8d1a-68a47d622eb6.png',
              'context': 'bigdata',
              'type': 'MICRO_APP',
              'url': 'https://bigdata.cosmoplat.cn',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1897194195379163136&appName=天数大数据',
              'enterNeedFresh': 0,
              description: '数据采集、治理、分析'
              // icon: 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/5e15cc1c-f1f0-45d4-8d1a-68a47d622eb6.png'
            }
            // {
            //   name: 'BI系统',
            //   'id': 1948275580088750080,
            //   // "name": "帆软BI",
            //   'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/16/94307b54-a2f1-4c17-a347-1b432db34ec1.png',
            //   'context': 'fineBI',
            //   'type': 'HREF',
            //   'url': 'https://sso.cosmoplat.com/sign/authz/oauth/v20/authorize?response_type=code&client_id=1948275580088750080&redirect_uri=https://eiip-bi.cosmoplat.net/webroot/decision',
            //   'accessApplyUrl': '',
            //   'enterNeedFresh': 0,
            //   description: '报表&数据大屏'
            //   // icon: 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/16/94307b54-a2f1-4c17-a347-1b432db34ec1.png'
            // }
          ],
          secondApps: [
            {
              name: '天智大模型',
              'id': 1970733878465400832,
              // "name": "天智模型训推",
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/24/6618fa9a-c849-4091-b896-d3747a5d1c30.png',
              'context': 'tzModel',
              'type': 'MICRO_APP',
              'url': 'https://develop-agent.hdt.cosmoplat.com/developAgent/',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '大模型引擎与模型调优'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1893859768993452032,
              'name': '低代码',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/53e20ac3-a30a-4fde-893a-28665f819873.png',
              'context': 'lcode',
              'type': 'MICRO_APP',
              'url': 'https://elcode.hdt.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1893859768993452032&appName=天马低代码',
              'enterNeedFresh': 0,
              description: '研发过程管理、代码仓与CICD流水线'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              name: 'BI系统',
              'id': 1948275580088750080,
              // "name": "帆软BI",
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/16/94307b54-a2f1-4c17-a347-1b432db34ec1.png',
              'context': 'fineBI',
              'type': 'HREF',
              'url': 'https://sso.cosmoplat.com/sign/authz/oauth/v20/authorize?response_type=code&client_id=1948275580088750080&redirect_uri=https://eiip-bi.cosmoplat.net/webroot/decision',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '报表&数据大屏'
              // icon: 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/16/94307b54-a2f1-4c17-a347-1b432db34ec1.png'
            },
            {
              'id': 1897193885927608320,
              'name': '机器学习',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/5106f995-30eb-4582-8fce-919d022e7e7f.png',
              'context': 'mlops',
              'type': 'MICRO_APP',
              'url': 'https://mlops.hdt.cosmoplat.com/mlops/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1897193885927608320&appName=天智机器学习',
              'enterNeedFresh': 0,
              description: '模型训练'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            }
          ]
        },
        {
          title: '智能驱动',
          content: '大小模型协同，提升智能精度；提供智能体开发工具、模型构建工具，支撑上层业务智能决策',
          apps: [
            {
              name: '物联IOT',
              'id': 1904089622397456384,
              // "name": "IOT物联",
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/8ae45db8-c595-4027-b34a-599144489c3e.png',
              'context': 'iot',
              'type': 'HREF',
              'url': 'https://cosmo-iot.hdt.cosmoplat.com/mom/oauthLogin?clientId=1904089622397456384',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1904089622397456384&appName=IOT物联',
              'enterNeedFresh': 0,
              description: '设备连接'
              // icon: '	http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/8ae45db8-c595-4027-b34a-599144489c3e.png'
            },
            {
              'id': 1897194195379163136,
              'name': '天数大数据',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/5e15cc1c-f1f0-45d4-8d1a-68a47d622eb6.png',
              'context': 'bigdata',
              'type': 'MICRO_APP',
              'url': 'https://bigdata.cosmoplat.cn',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1897194195379163136&appName=天数大数据',
              'enterNeedFresh': 0,
              description: '数据采集、治理'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1897193885927608320,
              'name': '天智机器学习',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/5106f995-30eb-4582-8fce-919d022e7e7f.png',
              'context': 'mlops',
              'type': 'MICRO_APP',
              'url': 'https://mlops.hdt.cosmoplat.com/mlops/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1897193885927608320&appName=天智机器学习',
              'enterNeedFresh': 0,
              description: '模型训练'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              name: '天智工业大模型',
              'id': 1970733878465400832,
              // "name": "天智模型训推",
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/09/24/6618fa9a-c849-4091-b896-d3747a5d1c30.png',
              'context': 'tzModel',
              'type': 'MICRO_APP',
              'url': 'https://develop-agent.hdt.cosmoplat.com/developAgent/',
              'accessApplyUrl': '',
              'enterNeedFresh': 0,
              description: '大模型引擎与模型调优'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              name: '智能体开发',
              'id': 1896752463223066624,
              // "name": "天智智能体开发",
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/060659d5-c3b2-433d-af01-12b72ebc268c.png',
              'context': 'developAgent',
              'type': 'MICRO_APP',
              'url': 'https://develop-agent.hdt.cosmoplat.com/developAgent/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1896752463223066624&appName=天智工业大模型',
              'enterNeedFresh': 1,
              description: '智能体开发、发布'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1935915907557756928,
              'name': '智能交互',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/09/fb6c186f-0f8c-4884-b7ad-1bb5bfafad2a.png',
              'context': 'agent-chat',
              'type': 'MICRO_APP',
              'url': 'https://develop-agent.hdt.cosmoplat.com/developAgent/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1935915907557756928&appName=智能交互',
              'enterNeedFresh': 1,
              description: '智能体应用'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            }
          ]
        },

        {
          title: '应用开发生命全周期管理',
          content: '对需求分析、开发、测试、部署、运维、到最终下线的全过程，进行统一、规范化和标准化管控',
          firstApps: [
            {
              'id': 1934442065744236544,
              'name': '应用台账',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/07/49327968-5590-426f-b865-5e0e95c6bd06.png',
              'context': 'application/index',
              'type': 'INNER_APP',
              'url': 'application/index',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1934442065744236544&appName=应用台账',
              'enterNeedFresh': 0,
              description: '创建台账'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1930796379400179712,
              'name': '流程中心',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/07/4fd84d66-dbc8-4694-9b39-133eea39ca14.png',
              'context': 'process',
              'type': 'MICRO_APP',
              'url': 'https://eip-oa-test.hdt.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1930796379400179712&appName=流程中心',
              'enterNeedFresh': 0,
              description: '云资源申请'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            }
          ],
          secondApps: [
            {
              'id': 837136275440926720,
              'name': 'DevOps',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/0e18b6ff-e174-481c-ae26-ac2e6e07ab76.png',
              'context': 'devsecopsweb',
              'type': 'MICRO_APP',
              'url': 'https://jdk11.hdt.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=837136275440926720&appName=DevOps',
              'enterNeedFresh': 0,
              description: '研发过程管理、代码仓与CICD流水线'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1077220875662524416,
              'name': '容器云',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/27/520e35a2-8ea8-46a5-9d09-c10b15524f06.png',
              'context': 'cke',
              'type': 'MICRO_APP',
              'url': ' https://container.y.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1077220875662524416&appName=容器云',
              'enterNeedFresh': 0,
              description: '镜像管理、服务部署'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            },
            {
              'id': 1893859768993452032,
              'name': '天马低代码',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/15/53e20ac3-a30a-4fde-893a-28665f819873.png',
              'context': 'lcode',
              'type': 'MICRO_APP',
              'url': 'https://elcode.hdt.cosmoplat.com/',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1893859768993452032&appName=天马低代码',
              'enterNeedFresh': 0,
              description: '研发过程管理、代码仓与CICD流水线'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            }
          ],
          thirdApps: [
            // {
            //   'id': 1077220875662524416,
            //   'name': '容器云',
            //   'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/04/27/520e35a2-8ea8-46a5-9d09-c10b15524f06.png',
            //   'context': 'cke',
            //   'type': 'MICRO_APP',
            //   'url': ' https://container.y.cosmoplat.com/',
            //   'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1077220875662524416&appName=容器云',
            //   'enterNeedFresh': 0,
            //   description: '镜像管理、服务部署'
            //   // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            // },
            {
              'id': 1930796379400179712,
              'name': '应用市场',
              'icon': 'http://oss.hdt.cosmoplat.com/portal-base/2025/07/07/4fd84d66-dbc8-4694-9b39-133eea39ca14.png',
              'context': 'process',
              'type': 'MICRO_APP',
              'url': 'https://econsole.cosmoplat.com/store',
              'accessApplyUrl': 'https://eiip.cosmoplat.com/itsm/#/itsm/ticket/create/eyJwcm9jZXNzRGVmaW5pdGlvbklkIjoicHJvY2Vzczo1ODozODAyNjM1IiwibmFtZSI6IuS8geW3peW5s+WPsOW6lOeUqOadg+mZkOeUs+ivtyJ9?appId=1930796379400179712&appName=流程中心',
              'enterNeedFresh': 0,
              description: '应用发版'
              // icon: 'https://img.alicdn.com/tfs/TB1.yqwxvzqK1RjSZFkXXX.WFXa-200-200.png'
            }
          ]
        },
        {
          title: '工业应用与行业适配',
          content: '集成内外部生态工业应用，打造化工、能源、智能制造等具备行业细分领域专属工业互联网平台',
          apps: [
            {
              name: '电子行业',
              img: require('@/assets/imgs/dianzi.png'),
              'url': 'https://electron.c.cosmoplat.com/'
            },
            {
              name: '化工行业',
              img: require('@/assets/imgs/huagong.png'),
              'url': 'https://chemic.c.cosmoplat.com/'
            },
            {
              name: '城市运营',
              img: require('@/assets/imgs/yunying.png'),
              'url': 'https://econsole-admin.c.cosmoplat.com/'
            },
            {
              name: '智能制造',
              img: require('@/assets/imgs/zhizao.png'),
              'url': 'https://manufact.c.cosmoplat.com/'
            },
            {
              name: '工赋城市',
              img: require('@/assets/imgs/chengshi.png'),
              'url': 'https://econsole.cosmoplat.com/'
            },
            {
              name: '能源行业',
              img: require('@/assets/imgs/nengyuan.png'),
              'url': 'https://energy.c.cosmoplat.com/'
            }
          ]
        }
      ],
      currentTab: 0 // 初始显示“智能驱动”标签页
    }
  },
  methods: {
    windowOpen(url) {
      window.open(url, '_blank')
    },
    /**
     * 点击跳转到子应用
     * @param {Object} appItem 应用信息项
     * @returns {void}
     */
    async clickApp(appItem) {
      if (appItem.context === this.$route.meta.context) {
        this.closeDialog()
        return
      }
      // appItem.canAccess &&
      //   incrementQuickApps(appItem.id).then((res) => {
      //     console.log(`访问${appItem.name}`)
      //   })
      const res = await getAppApplyUrl({ appId: appItem.id })
      const accessApplyUrl = res.data
      sessionStorage.setItem('accessApplyUrl', accessApplyUrl)
      // if (appItem.canAccess) {
      if (appItem.enterNeedFresh == '1') {
        microApp.unmountAllApps().then(() => {
          window.open(
            window.location.origin + '/' + appItem.context + '/',
            '_self'
          )
        })
      } else if (appItem.type == 'HREF') {
        window.open(appItem.url, '_blank')
      } else {
        microApp.unmountAllApps().then(() => {
          this.$router.push(`/${appItem.context}/`)
        })
      }
      // }
      // else {
      //   // window.location.href = '/noPermission'
      //   // localStorage.setItem("beforeApp", appItem.name);
      //   this.$router.push(`/noPermission?appName=${appItem.name}`)
      // }
      // this.$store.commit('app/SET_POPPER_SHOW', false)
      this.closeDialog()
    },
    openDialog() {
      this.visible = true
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.tab_content-item-app-special {
  padding-top: 24px;
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  background-image: linear-gradient(180deg, #ffffffb3 0%, #ffffff00 100%);
  border: 1px solid #FFFFFF;
  box-shadow: 0 0 20px 0 #0000000a, inset 0 -12px 20px 0 #4a5ff30a;
  border-radius: 12px;
  &:hover {
    background-image: linear-gradient(180deg, #ffffffb3 0%, #ffffff00 100%);
    border: 1px solid #4A5FF3;
    box-shadow: 0 5px 16px 0 #4a5ff352, inset 0 -12px 20px 0 #0020ff1f;
    .item-app-title-special {
      color: #4A5FF3;
    }
  }
}
.item-app-title-special {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  margin-top: 2px;
}
.first_app-footer {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}
.second_app-item-img {
  position: absolute;
  width: 74px;
  height: 61px
}
.zuoshang_img {
  top: 68px;
  left: -80px;
}
.zuoxia_img {
  bottom: 76px;
  left: -80px;
}
.youshang_img {
  bottom: 76px;
  right: -80px;
}
.youxia_img {
  top: 68px;
  right: -80px;
}
.special-app:nth-last-child(3) {
  margin-right: 0 !important;
  &::after {
    content: none !important;
    display: none !important;
  }
}
.tab_content-item-app-second {
  margin: 0 90px;
  width: 380px;
  height: 336px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  position: relative;
}
.ability_container {
  display: flex;
  flex-direction: row;
  gap: 18px;
  margin-top: 80px;
}
.ability_item {
  flex: 1;
  width: 408px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  height: 326px;
  background: #ffffff54;
}
.ability_item-title {
  margin-top: 8px;
  margin-bottom: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  line-height: 20px;
}
.ability_item-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
}
.ability_item-content-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffffa8;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
  background: #FFFFFF;
  box-shadow: 0 2px 8px 0 #0000001a;
}
}
.ability_item-content-title {
  font-family: PingFangSC-Semibold;
font-weight: 600;
font-size: 16px;
color: #333333;
letter-spacing: 0;
margin-top: 40px;
}
.ability_item-content-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  margin-top: 28px;
  margin-bottom: 30px;
}
.ability_item-content-desc {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #808080;
  letter-spacing: 0;
}
.wulian_bg {
  width: 233px;
  height: 408px;
  position: absolute;
  top: 50%;
  right: 75%;
  // left: 50%;
  // transformY: translate(-50%, -50%);
  transform: translateY(-50%);
  @media screen and (max-width: 1440px) {
    width: 160px;
    height: auto;
    top: 260px;
    right: 76%;
    // transform: translateY(0);
  }
}
.full-screen-dialog-overlay {
  position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(228, 225, 234, 0.8);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    filter: grayscale(0) !important;
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
}
.full-screen-dialog-content {
  width: 1356px;
    height: 680px;
    max-width: 90%;
    max-height: 90%;
    filter: grayscale(0) !important;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(255, 255, 255, 0.8);
    /* padding: 18px; */
}
.flow_dialog-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* margin-bottom: 20px; */
  padding: 18px;
}
.flow_dialog-title {
  padding-left: 42px;
  margin-top: 4px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 32px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
.tabs {
  flex-shrink: 0;
  display: flex;
  margin-bottom: 10px;
  padding-bottom: 10px;
  padding-left: 42px;
  overflow-x: auto; /* 标签过多时可横向滚动 */
}
.dialog-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff66;
  position: relative;
  overflow-y: auto;
  /* 内容区域样式可根据需要调整 */
}
.flow_tab {
  /* width: 102px; */
  padding: 0 16px;
  height: 32px;
  background: #F8F8F8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;
  margin-right: 16px;
  cursor: pointer;
}
.active-tab {
  background: #EDF1FB;
  border: 1px solid #4A5FF3;
  color: #4A5FF3;
  position: relative;
}
.active-tab::after {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  border-top: 6px solid #4A5FF3;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 0;
  width: 0;
  height: 0;
  z-index: 1;
}
.tab_content-item {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tab_content-item-title {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 24px;
  color: #4A5FF3;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 60px;
}
.tab_content-item-content {
  margin-top: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4A5FF3;
  letter-spacing: 0;
  line-height: 16px;
}
.tab_content-item-apps {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 38px;
}
.tab_content-item-second_app {
  width: 368px;
  height: 368px;
  background: #ffffff54;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 16px;
  padding: 16px;
  padding-bottom: 32px;
  position: relative;
}
.tab_content-item-first_app {
  width: 368px;
  height: 368px;
  background: #ffffff54;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 16px;
  padding: 16px;
  padding-bottom: 32px;
  margin-right: 40px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    right: -30px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 30px;
    background: url('@/assets/imgs/split.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}
.first_app-item {
  background: #ffffffa8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 #0000001a;
  }
}
.first_app-item-title {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin-top: 28px;
  margin-bottom: 16px;
}
.first_app-item-img {
  width: 60px;
  height: 60px;

  border-radius: 4px;
}
.first_app-item-new {
  width: 160px;
  height: 160px;
  background: #ffffffa8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  &:hover {
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 #0000001a;
  }
}
.first_app-item-new:nth-child(odd) {
  &::after {
    content: "";
    position: absolute;
    right: -42px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 30px;
    background: url('@/assets/imgs/split.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}
.first_app-item-title-new {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin-top: 28px;
  margin-bottom: 16px;
}
.first_app-item-img-new {
  width: 60px;
  height: 60px;

  border-radius: 4px;
}
.tab_content-item-app {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  height: 240px;
  background: #ffffffa8;
  border-radius: 8px;
  padding: 0 20px;
  cursor: pointer;
  @media screen and (max-width: 1440px) {
    width: 155px;
  }
  &:hover {
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 #0000001a;
  }
}
.tab_content-item-app:not(:last-child) {
  margin-right: 40px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    right: -30px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 30px;
    background: url('@/assets/imgs/split.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}
.item-app-title {
  margin-top: 40px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin-bottom: 28px;
}
.tab_content-item-app-description {
  margin-top: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #808080;
  letter-spacing: 0;
  text-align: center;
}
.lcode_apps {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  padding: 8px;
  cursor: default;
  &:hover {
    background: #ffffffa8!important;
    box-shadow: none!important;;
  }
}
.lcode_app {
  margin-top: 16px;

}
</style>
